// extracted by mini-css-extract-plugin
export var active = "_3d-7";
export var container = "_3d-0";
export var evenWidth = "_3d-4";
export var large = "_3d-5";
export var outlet = "_3d-8";
export var slide = "_3d-2";
export var small = "_3d-6";
export var tab = "_3d-3";
export var tabs = "_3d-1";